var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-cell"},[_c('div',{staticClass:"activity-head"},[_c('div',{staticClass:"activity-name font-h6-medium fz-12"},[_vm._v(_vm._s(_vm._f("formatEmpty")(_vm.row.activity_name)))])]),_c('div',{staticClass:"activity-bottom font-h6-medium fz-12"},[_vm._v("活动ID："+_vm._s(_vm._f("formatEmpty")(_vm.row.activity_id)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }